import { SDate } from '@summit/core';
import { DaysOfWeek, NumberFormatter, SummitFormattedText } from '@summit/models';
import { Dayjs } from 'dayjs';
import { EboNameObject } from '../../base-classes/ebo-name-object';
import { Employee } from '../../employee/employee';
import { EmployeePayrollGroup } from '../../employee/employee-payroll-group';
import { EmployeeStatus, EmployeeStatusMapping } from '../../employee/status/employee-status.enum';
import { Company } from '../../organization/company/company';
import {
  WageEmployeeFilterType,
  WageEmployeeFilterTypeMapping
} from '../../shared/payroll/wage-employee-filter-type.enum';

export interface IWageRuleOrdered {
  ruleSetId: string;
  ruleSet: EboNameObject;

  ruleOrder: number;
  createdDate: Dayjs;
  employeeFilterType: WageEmployeeFilterType;
  employeeId: string;
  employee: Employee;
  companyId: string;
  company: Company;
  payrollGroupId: string;
  payrollGroup: EmployeePayrollGroup;
  employeeStatus: EmployeeStatus;
  days: DaysOfWeek;
  invertFilter: boolean;

  //Not part of Server's IWageRuleOrdered but needed for sorting
  startTime: Dayjs;
  endTime: Dayjs;

  get defaultSort(): string;
  get applicableEmployee(): SummitFormattedText;
}

export function GetDefaultSortString<T extends IWageRuleOrdered>(item: T): string {
  const response = new Array<string>();
  if (item === undefined || item === null) return undefined;
  if (SDate.isDayjs(item.endTime)) {
    response.push(item.endTime?.format('YYYYMMDD'));
  } else {
    response.push('--------');
  }
  response.push(NumberFormatter(item.ruleOrder, 4));
  response.push(item.employee ? item?.employee.name : '~');
  response.push(item.payrollGroup ? item.payrollGroup.name : '~');
  response.push(item.startTime?.format('YYYYMMDD'));
  //console.log(`Processed -> result`, this, response);
  return response.join('-');
}

export function GetApplicableEmployee<T extends IWageRuleOrdered>(
  item: T,
  ruleSetPath?: string[]
): SummitFormattedText {
  const response = new SummitFormattedText();
  if (item.ruleSetId?.length > 0)
    response.AddLine(
      `[Rule Set]  ${item.ruleSet?.name}`,
      null,
      ruleSetPath
        ? {
            path: ruleSetPath
          }
        : undefined
    );
  if (!item.ruleSetId) {
    if (item.employeeFilterType == WageEmployeeFilterType.Employee && item.employeeId)
      if (item.invertFilter) response.AddLine(`Not ${item.employee?.name}`);
      else response.AddLine(item.employee?.name);
    if (item.employeeFilterType == WageEmployeeFilterType.ByGroup && item.payrollGroupId)
      if (item.invertFilter) response.AddLine(`Not ${item.payrollGroup?.name}`);
      else response.AddLine(item.payrollGroup?.name);
    if (item.employeeFilterType == WageEmployeeFilterType.ByEmployeeCompany && item.companyId)
      if (item.invertFilter) response.AddLine(`Not ${item.company?.name}`);
      else response.AddLine(item.company?.name);
    if (
      item.employeeFilterType == WageEmployeeFilterType.EmployeeStatus &&
      item.employeeStatus !== undefined &&
      item.employeeStatus !== null
    )
      if (item.invertFilter) response.AddLine(`Not ${EmployeeStatusMapping[item.employeeStatus]}`);
      else response.AddLine(EmployeeStatusMapping[item.employeeStatus]);
  }
  if (response.lines.length == 0) response.AddLine(WageEmployeeFilterTypeMapping[WageEmployeeFilterType.All]);
  //console.log(`GetApplicableEmployee ${response.toString()}`, item);
  return response;
}
